<template>
    <div>
        <div class="p-layout-breadcrumb">
            <el-row type="flex" align="middle">
                <el-col :span="3">
                    <h3>编辑甄选享玩设置</h3>
                </el-col>
            </el-row>
        </div>
        <el-form :model="shopForm" ref="shopForm" :rules="addShopRules">
            <el-form-item label="享玩甄选描述" label-width="150px" prop="description">
                <el-input v-model="shopForm.name"></el-input>
            </el-form-item>
            <el-form-item label="商品选择" label-width="150px">
                <el-select v-model="shopForm.shop" @change="productChoose">
                    <el-option v-for="item in productArr" v-if="item.isOnline" :key="item.productDetailId" :label="item.name" :value="item.productDetailId">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="当前租金(元)" label-width="150px">
                <el-input v-model="shopForm.product.rental" :disabled="true"></el-input>
            </el-form-item>
            <el-form-item label="原租金(元)" label-width="150px" prop="oldRental">
                <el-input v-model="shopForm.product.oldRental"></el-input>
            </el-form-item>
    
            <el-form-item label-width="150px">
                <el-button type="primary" @click="onSubmit">保存</el-button>
                <el-button @click="goBack">取消</el-button>
            </el-form-item>
        </el-form>
    
    </div>
</template>

<script>
    import {
        getVersions,
        getGlobalSettings,
        filterIndexVersions,
        getProductCategories,
        getProductTags,
        getProductDetails,
        getProductDetailsOnly
    } from '../../api/version'
    
    export default {
        data() {
            return {
                shopForm: {
                    price_current: '',
                    price_old: '',
                    name: '',
                    shop: this.$route.params.id*1,
                    product: '',
                    description: ''
                },
                addShopRules: {
                    name: [{
                        required: true,
                        message: '请输入享玩甄选描述',
                        trigger: 'blur'
                    }],
                    shop: [{
                        type: 'number',
                        required: true,
                        message: '请选择商品',
                        trigger: 'blur'
                    }]
                },
                uptoken: {
                    token: sessionStorage.token
                },
                productArr: [],
    
            }
        },
        created() {
    
            getProductDetailsOnly(sessionStorage.userId,JSON.stringify({where:{accessoryType: 0}})).then(res => {
                this.productArr = res.data
                let currentData = this.$store.state.currentIndex.value.product
                let _id = this.$route.params.id
                let ids = ''
    
                currentData.forEach(item => {
                    if (item.name === _id) {
                        // this.shopForm = item
                        this.shopForm.name = item.name
                        this.shopForm.price_current = item.price_current
                        this.shopForm.price_old = item.price_old
                        ids = item.targetId
                    }
                })
                res.data.forEach(item => {
                    if (item.productDetailId === ids) {
                        this.shopForm.product = item
                        this.shopForm.shop = ids
                        this.shopForm.product.rental = this.shopForm.price_current
                        this.shopForm.product.oldRental = this.shopForm.price_old
                    }
                })
                this.$store.commit('SETTOPICARR', this.productArr);
            })
        },
        methods: {
            goBack() {
                //取消
                this.$router.push('/shopList')
            },
            productChoose(val){
                this.productArr.forEach( item => {
                    if(item.productDetailId === val) {
                        this.shopForm.product = item
                        this.shopForm.shop = item.productDetailId
                    }
                })
                
            },
            onSubmit() {
                console.log(this.shopForm)
                this.$refs['shopForm'].validate((valid) => {
                    if (valid) {
                        this.shopForm.price_current = this.shopForm.product.rental
                        this.shopForm.price_old = this.shopForm.product.oldRental
                        this.shopForm.targetId = this.shopForm.product.productDetailId
                        this.shopForm.name = this.shopForm.name
                        this.shopForm.description = this.shopForm.product.name
                        this.shopForm.picUrl = this.shopForm.product.media.pic[0]
    
                        let currentData = this.$store.state.currentIndex
                        let current = JSON.parse(JSON.stringify(this.shopForm))
                        delete current.product
                        delete current.shop
                        current.targetid = current.targetId
                        currentData.value.product.forEach( (item, index) => {
                            if(item.name === this.$route.params.id) {
                                console.log('!')
                                currentData.value.product[index] = current
                            }
                        })
                        this.$store.commit('SETCURRENTINDEX', currentData);
                        this.$router.push('/shopList')
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
        }
    }
</script>

<style>
    .avatar-uploader .el-upload {
        background-color: #fbfdff;
        border: 1px dashed #c0ccda;
        border-radius: 6px;
        cursor: pointer;
        position: relative;
        overflow: hidden;
    }
    
    .avatar-uploader .el-upload:hover {
        border-color: #20a0ff;
    }
    
    .avatar-uploader-icon {
        font-size: 28px;
        color: #8c939d;
        width: 178px;
        height: 178px;
        line-height: 178px;
        text-align: center;
    }
    
    .avatar {
        width: 178px;
        height: 178px;
        display: block;
    }
    
    .el-upload-list {
        display: flex;
    }
    
    .el-upload-list--picture .el-upload-list__item {
        width: 300px;
        margin-right: 15px;
    }
</style>




// WEBPACK FOOTER //
// EditShop.vue?507b9ceb